import React, { useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import ProfileTab from "../../components/settings/generalsettings/ProfileTab";
import SecurityTab from "../../components/settings/generalsettings/SecurityTab";
import NotificationsTab from "../../components/settings/generalsettings/NotificationsTab";
import ConnectedAppsTab from "../../components/settings/generalsettings/ConnectedAppsTab";


export default function GeneralSettings() {
  const [activeTab, setActiveTab] = useState("profile");

  const renderTab = () => {
    switch (activeTab) {
      case "profile":
        return <ProfileTab />;
      case "security":
        return <SecurityTab />;
      case "notifications":
        return <NotificationsTab />;
      case "apps":
        return <ConnectedAppsTab />;
      default:
        return <ProfileTab />;
    }
  };

  return (
    <Row>
      {/* SIDEBAR */}
      <Col lg={3} md={4}>
        <Card className="sidebar-card">
          <div
            className={`sidebar-item ${activeTab === "profile" && "active"}`}
            onClick={() => setActiveTab("profile")}
          >
            › Profile Settings
          </div>

          <div
            className={`sidebar-item ${activeTab === "security" && "active"}`}
            onClick={() => setActiveTab("security")}
          >
            Security Settings
          </div>

          <div
            className={`sidebar-item ${activeTab === "notifications" && "active"}`}
            onClick={() => setActiveTab("notifications")}
          >
            Notifications
          </div>

          <div
            className={`sidebar-item ${activeTab === "apps" && "active"}`}
            onClick={() => setActiveTab("apps")}
          >
            Connected Apps
          </div>
        </Card>
      </Col>

      {/* CONTENT */}
      <Col lg={9} md={8}>
        <Card className="content-card">{renderTab()}</Card>
      </Col>
      <style>

        {

          `
          .sidebar-card {
  padding: 15px;
}

.sidebar-item {
  padding: 12px;
  cursor: pointer;
  border-radius: 6px;
}

.sidebar-item.active {
  background: #fff3e0;
  color: #ff6a00;
}

.content-card {
  padding: 20px;
}

.upload-box {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
}

.upload-circle {
  width: 60px;
  height: 60px;
  background: #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-orange {
  background: #ff6a00;
  color: white;
  border: none;
}

.setting-row {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.toggle-group {
  display: flex;
  gap: 10px;
}

.app-card {
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 8px;
}

/* MOBILE */
@media (max-width: 768px) {
  .sidebar-card {
    display: flex;
    overflow-x: auto;
  }
}`
        }
      </style>
    </Row>
  );
}